"use client";

import { Controller, useFormContext } from "react-hook-form";
import Input from "../common/input/input";
import Button from "../common/button";
import ProgressBar from "../common/progress-bar";
import LottieAnimation from "../common/animations";
import { CaretRight, OptionIcon } from "../../icons";

const SocialsComp = () => {
  const {
    control,
    formState: { errors, isSubmitting },
  }: any = useFormContext();

  return (
    <div className="h-full w-full flex flex-col justify-between">
      <div>
        <div className="flex items-center flow-root ">
          <div className="w-32 md:mb-10 mb-6 float-left">
            <div
              className="cursor-pointer mb-3 "
              onClick={() => {
                window.history.back();
              }}
            >
              <div className="rotate-180 transform origin-left ml-5">
                <CaretRight />
              </div>
            </div>
            <LottieAnimation lottieUrl="/animation/Logo.lottie" height="40px" />
          </div>

          <div className="mt-12 ml-4 w-1/5 float-right">
            <ProgressBar currentStep={4} totalSteps={5} />
          </div>
        </div>
        <div className="text-2.8xl text-white leading-10 font-bold mb-4">
          Almost Done!
        </div>
        <div className="">
          <div className="w-full mb-5">
            <Controller
              name={`linkedin`}
              control={control}
              render={({ field: { value, onChange } }) => {
                return (
                  <Input
                    id={`liknedin`}
                    name={`linkedin`}
                    customClassName="bg-[#262626] text-white px-3 py-4 w-full"
                    maxLength={200}
                    showError={true}
                    errorMessage={errors?.linkedin?.message}
                    value={value}
                    onChange={onChange}
                    placeholder={"Linkedin URL"}
                  />
                );
              }}
            />
          </div>
        </div>
        <div className="flow-root">
          <div className="text-2.8xl text-gray-200 leading-1 text-md mb-10 float-left font-bold ">
            Earn XP for this action
          </div>
          <div className="flex items-center text-gray-600 text-sm float-right">
            <div className="flex items-center space-x-1 bg-primary-600 w-14 rounded-full border border-solid border-primary-200">
              <img
                src="/assets/icons/star-red.png"
                alt=""
                className="ml-2 w-4 h-4"
              />
              <span className="ml-1 text-[#ECD996] font-bold">25</span>
            </div>
          </div>
        </div>
        <div className="text-[#808080] flex flex-col text-[13px] gap-2 mt-10">
          <span className=" text-[#BDBDBD] text-[17px] md:mb-2">
            How to connect?
          </span>
          <span>Step 1: Go to Linkedin</span>
          <span>Step 2: Go to your Profile</span>
          <span className="flex flex-row">
            Step 3: Click on the options button{" "}
            <div className="ml-1">
              <OptionIcon />
            </div>{" "}
          </span>
          <span>Step 4: Copy profile URL</span>
        </div>
      </div>

      <div>
        <Button
          isSubmitting={isSubmitting}
          customClasses="w-full mb-5 rounded-xl"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default SocialsComp;
